<div id="content" class="allcp-form" ng-controller="WorkerAnalyticController">
    <div ng-include="'modules/company/menus/report_menu.html'"></div>
    <div class="panel-body">
            
        <div class="table-responsive" ng-if="data.data.length > 0">
            <table class="table table-hover tc-checkbox-1 fs13">
                <thead class="p20">
                    <tr class="bg-light">
                        <th>Full Name</th>
                        <th>Phone</th>
                        <th>On Delivery Orders</th>
                        <th>Completed Orders</th>
                        <th>Unsuccessful Orders</th>
                        <th>Total Orders</th>
                    </tr>
                </thead>
                <tbody>
                <tr class="text-left" ng-repeat="item in data.data">
                    <td class="clickable-row" ng-click="getWorkerDetails(item.id)">
                        <div class="avatar-container text-left pl20">
                            <div class="avatar-img">
                                <img ng-src="https://s3.us-west-2.amazonaws.com/hodxpress/{{ item.profile_photo }}" class="img-responsive text-center img-circle" width="36px" height="36px" style="width:36px;  height:36px;" alt="">
                            </div>
                            <div class="avatar-detail">
                                <strong style="font-weight:bold">{{item.user.full_name}}</strong>
                                {{item.user.email}}
                            </div>
                        </div>
                    </td>
                    <td class="clickable-row" ng-click="getWorkerDetails(item.id)">{{ item.phone_number }}</td>
                    <td>
                        {{ item.on_delivery }}
                    </td>
                    <td>
                        {{ item.success }}
                    </td>
                    <td>
                        {{ item.fail }}
                    </td>
                    <td>
                        {{ item.total }}
                    </td>
                </tr>
                </tbody>
            </table>
        </div>

        <div class="table-responsive" ng-if="data.data.length == 0">
            <div class="alert alert-default pastel">
                <i class="fa fa-info pr10"></i>
                <strong>
                    Driver Not Found!
                </strong>
            </div>
        </div>

    </div>
</div>